import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import capitalizeFirstLetter from 'ggApp/utils/capitalizeFirstLetter';
import PaymentIframeInputUi from './PaymentIframeInputUi';

const PaymentIframeInput = ({
    iframeInputStyleObject,
    iframeTargetId,
    label,
    error,
    isEmpty,
    paymentLibrary,
    fieldType,
    onBlur,
    theme,
    uiComponent,
}) => {
    const [isFocused, setFocus] = useState(false);
    const eventHandlerMethod = `${fieldType}On`;
    const styleSetMethod = `set${capitalizeFirstLetter(fieldType)}Style`;

    const getIframeInputColor = ({ mode }, isActive) => {
        const isDarkMode = mode === 'dark';
        // eslint-disable-next-line no-nested-ternary
        return isDarkMode ? 'white' : isActive ? '#3D02FF' : '#333333';
    };

    useEffect(() => {
        if (!paymentLibrary) return;
        paymentLibrary[styleSetMethod](iframeInputStyleObject(theme));
        paymentLibrary[eventHandlerMethod]('focus', () => {
            setFocus(true);
            paymentLibrary[styleSetMethod]({
                color: getIframeInputColor(theme, true),
            });
        });
        paymentLibrary[eventHandlerMethod]('blur', () => {
            setFocus(false);
            onBlur();
            paymentLibrary[styleSetMethod]({
                color: getIframeInputColor(theme, false),
            });
        });
    }, [paymentLibrary, eventHandlerMethod, styleSetMethod, onBlur, theme, iframeInputStyleObject]);

    const IframeUiComponent = uiComponent || PaymentIframeInputUi;
    return (
        <IframeUiComponent
            iframeTargetId={iframeTargetId}
            label={label}
            error={error}
            isEmpty={isEmpty}
            isFocused={isFocused}
        />
    );
};

PaymentIframeInput.propTypes = {
    iframeTargetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired,
    paymentLibrary: PropTypes.instanceOf(window.PaymentJs),
    fieldType: PropTypes.oneOf(['number', 'cvv']).isRequired,
    onBlur: PropTypes.func,
    error: PropTypes.node,
    theme: PropTypes.shape({
        mode: PropTypes.string,
    }).isRequired,
    isEmpty: PropTypes.bool.isRequired,
};

PaymentIframeInput.defaultProps = {
    paymentLibrary: null,
    onBlur: () => {},
    error: null,
};

export default withTheme(PaymentIframeInput);
